import * as React from "react";
import { Button, Divider, Typography } from "@mui/material";
import { PageContainer } from "#pages/PageContainer";
import { useAppSelector } from "#store";
import JsonView from "react-json-view";
import { useDispatch } from "react-redux";
import { OperatorInvocation } from "#services/pilotService/types";
import { ObjectTable } from "#common/ObjectTable";
import { useEffect } from "react";
import { H1 } from "#common/headings";
import { OperatorView, selectAllOperatorInvocations } from "#selectors";
import { listOperatorInvocationsFromServer } from "#store/operatorInvocations/operatorInvocationActions";
import { listActionsFromServer } from "#store/actions/actionActions";

export const OperatorInvocationListingPage = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(listOperatorInvocationsFromServer());
    }, []);

    const operatorInvocations: OperatorView[] = useAppSelector(state =>
        selectAllOperatorInvocations(state)
    );
    const os = operatorInvocations.map(o => {
        return o.operator;
    });

    return (
        <PageContainer>
            <H1>Operator invocations</H1>
            <Typography variant={"body1"}>
                This listing shows all invocations of operators along with its
                data
            </Typography>
            <ObjectTable
                data={os as unknown as Array<Record<string, unknown>>}
            />
            <Divider />
        </PageContainer>
    );
};
